import type { IAppState } from 'shared/common/state';

export const selectFullPriceByOfferId =
  (offerId: number) =>
  (state: IAppState): number | null => {
    const pricesData = state.etazhiBlackFriday?.pricesData;

    return pricesData?.[offerId] ?? null;
  };
